module.exports = __webpack_public_path__ + "img/home_h.e57d5242.svg";